import {
  IDefaultProfileScoreCategory,
  IMergedProfileScoreCategory,
  ProfileScoreCategory,
} from '../../../../interfaces/gamification.interface';

export const mergeProfileScoreCategories = (
  userCategories: ProfileScoreCategory[],
  defaultCategories: IDefaultProfileScoreCategory[]
): IMergedProfileScoreCategory[] => {
  return userCategories.map(category => {
    const defaultCat = defaultCategories.find(
      d => d.name.toLowerCase() === category.name.toLowerCase()
    );

    return {
      ...category,
      icon: defaultCat ? defaultCat.icon : null,
      link: defaultCat ? defaultCat.link : null,
      buttonText: defaultCat ? defaultCat.buttonText : null,
    };
  });
};
